import { render, staticRenderFns } from "./ProjectQuestionnaireEdit.vue?vue&type=template&id=bd3ca508&"
import script from "./ProjectQuestionnaireEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectQuestionnaireEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports